import React, { CSSProperties, FC } from 'react';


interface TextProps {
    size?: 'xs' | 'sm' | 'base' | 'lg' | 'xl' | 'xxl' | 'xxxl' | 'xxxxl';
    color?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'muted' | 'orange';
    isBlock?: boolean;
    children: React.ReactNode; // Type for children
    className?: string; // Optional additional class names
    onClick?: React.MouseEventHandler<HTMLHeadingElement>;
    style?: CSSProperties; 
}


export const Text: FC<TextProps> = ({ size = 'base', color, isBlock=true, children, className = '', onClick, ...props }) => {
    const colorClass = color ? `text-${color}` : '';
    const blockClass = isBlock ? 'display-block' : ''
    const classNames = `text-${size} ${colorClass} ${className} ${blockClass}`.trim();

    return (
        <span className={classNames} onClick={onClick} {...props}>
            {children}
        </span>
    );
};


interface TitleProps {
    children: React.ReactNode; // Type for children
    className?: string; // Optional additional class names
}

interface DetailProps {
    children: React.ReactNode; // Type for children
    href: string;
    className?: string;
    bg?: 'bg-primary' | 'bg-secondary' | 'bg-gray' | 'bg-transparent' | 'bg-success' | 'bg-warning' | 'bg-danger';
    r?: 'r15' | 'r10' | 'r5' | 'r0';
    p?: 'p4' | 'p3' | 'p2' | 'p1' | 'p0';
    color?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'muted' | 'orange';
    style?: CSSProperties;
}

interface GoBackProps {
    children: React.ReactNode; // Type for children
    onClick?: React.MouseEventHandler<HTMLHeadingElement>;
}

export const Title: FC<TitleProps> = ({ children, className = '', ...props }) => {
    const classNames = `${className}`.trim();

    return (
        <h1 className={classNames} {...props}>
            {children}
        </h1>
    );
};


export const SubTitle: FC<TitleProps> = ({ children, className = '', ...props }) => {
    const classNames = `${className}`.trim();

    return (
        <h2 className={classNames} {...props}>
            {children}
        </h2>
    );
}


export const DetailText: FC<DetailProps> = ({ children, href, 
    className='', 
    bg='bg-transparent',
    r='r0', 
    p='p0',
    color="orange",
    style, 
    ...props 
}) => {
    const classValue = (`cursor-pointer ${bg} ${r} ${p} text-${color}` + ' ' + className).trim()
    return (
        <span className={classValue} onClick={(e) => {window.open(href, '_self')}} {...props} style={style}>
            {children}
        </span>
    )
}

export const GoBackText: FC<GoBackProps> = ({ children, onClick, ...props }) => {
    return (
        <span className='detailText' onClick={onClick}>
            {children}
        </span>
    )
}

export const Tag: FC<TextProps> = ({ size = 'xs', color="dark", isBlock=true, children, className = '', onClick, ...props }) => {
    const colorClass = color ? `text-${color}` : '';
    const blockClass = isBlock ? 'block' : ''
    const classNames = `bg-light p05 r5 tag-border text-${size} ${colorClass} ${className} ${blockClass}`.trim();

    return (
        <span className={classNames} onClick={onClick} {...props}>
            {children}
        </span>
    );
};